import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { AccountEndpoint } from '../../../services/account-endpoint.service';
import { AccountService } from '../../../services/account.service';
import { DBkeys } from '../../../services/db-Keys';
import { ElectricityService } from '../../../services/electricity.service';
import { LocalStoreManager } from '../../../services/local-store-manager.service';
var _ = require('lodash');
require('chart.js');

@Component({
    selector: 'electricity-statistics',
    template: require('./electricity-statistics.component.html'),
    styles: [require('./electricity-statistics.component.css')],
})
export class ElectricityStatisticsComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    @Input('monthsCount') monthsCount: number;
    suggestedMin: number = 30;
    suggestedMax: number = 50;
    Min: number = 30;
    Max: number = 50;
    electricityStatistics: any;
    electricityCount: number;
    chartData: Array<any> = [];
    chartLabels: Array<any> = [];
    chartOptions: any;
    chartColors: Array<any> = [
        {
            // Light red
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 99, 132, 0.8)'
        },
        {
            // Bright blue
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            pointBackgroundColor: 'rgba(54, 162, 235, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(54, 162, 235, 0.8)'
        },
        {
            // Light orange
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(255, 206, 86, 1)',
            pointBackgroundColor: 'rgba(255, 206, 86, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 206, 86, 1)'
        },
        {
            // Moderate cyan
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            pointBackgroundColor: 'rgba(75, 192, 192, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(75, 192, 192,0.8)'
        }
    ];
    chartLegend: boolean = true;
    chartType: string = 'line';
    loading: boolean = false;
    applicationVersionName: any;

    constructor(private electricityService: ElectricityService, private ngxLogger: NGXLogger, private storageManager: LocalStoreManager,
        private accountService: AccountService, private accountEndpoint: AccountEndpoint) { }

    ngOnInit() {
        this.loading = true;
        this.applicationVersionName = this.accountService.applicationVersionName;
        const getStatiSubscriber = this.electricityService.getStatistics(this.monthsCount).subscribe((res: any) => {
            this.loading = false;
            if (res.Item2 && res.Item1 != null) {
                this.refreshChart(res.Item1, res.Item3);
            } else {
                let OChartData, OChartLabels, OMin, OMax;
                if (res.Item3) {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYTRIALCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYTRIALCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYTRIALMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYTRIALMAX);
                } else {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.ELECTRICITYMAX);
                }

                if (OChartData != null && OChartLabels != null && OMin != null && OMax != null) {
                    this.refreshMemoryChart(OChartData, OChartLabels, OMin, OMax);
                } else if (OChartData == null || OChartLabels == null || OMin == null || OMax == null) {
                    this.electricityService.getCacheStatistics(this.monthsCount).subscribe((res: any) => {
                        if (res.Item1 != null) {
                            this.refreshChart(res.Item1, res.Item2);
                        }
                    });
                }
            }
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(getStatiSubscriber);
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    refreshChart(res, trial) {

        let temp = _(res)
            .map((value, key) => ({ Data: value.SettlementPrice }))
            .value();

        let minFilter = temp.filter(gc => gc.Data != 0 && gc.Data != null);

        this.Max = Math.max.apply(Math, temp.map(function (o) { return o.Data; }));

        // this.suggestedMin = Math.floor(_.minBy(res, 'SettlementPrice').SettlementPrice) - 5;

        this.electricityStatistics = _(res).groupBy(x => x.StripName)
            .map((value, key) => ({ StripName: key, Data: value }))
            .value();

        this.Min = Math.min.apply(Math, minFilter.map(function (o) { return o.Data; }));

        // creates an array of the `value` property: [100, 22, 12]
        let numbers = this.electricityStatistics.map(i => i.Data.length);
        // gets the sum of the array of numbers: 134
        this.electricityCount = numbers.reduce((a, b) => a + b, 0);

        this.loading = false;

        if (this.electricityStatistics != null && this.electricityStatistics !== undefined && this.electricityStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.electricityStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.electricityStatistics[0].Data.length);
            _chartLabels = _.map(this.electricityStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.electricityStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.electricityStatistics[i].Data.length), label: this.electricityStatistics[i].StripName };
                for (let j = 0; j < this.electricityStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.electricityStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartData = _chartData;
            this.chartLabels = _chartLabels;
            this.chartOptions = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            // beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.Min,
                            max: this.Max
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };

            if (this.applicationVersionName == null || this.applicationVersionName == undefined) {
                this.accountEndpoint.getApplicationVersionName().subscribe(res => {
                    this.applicationVersionName = res;
                    this.GetdataLocalSt(trial, _chartData, _chartLabels);
                });
            } else {
                this.storageManager.setApplicationVersion(this.applicationVersionName, DBkeys.APPLICATIONVERSION);
                this.GetdataLocalSt(trial, _chartData, _chartLabels);
            }
        }
    }

    GetdataLocalSt(trial, _chartData, _chartLabels) {
        if (trial) {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.ELECTRICITYTRIALCHARTDATA);
            this.storageManager.setchartLabels(_chartLabels, this.applicationVersionName + "_" + DBkeys.ELECTRICITYTRIALCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.ELECTRICITYTRIALMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.ELECTRICITYTRIALMIN);

        } else {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.ELECTRICITYCHARTDATA);
            this.storageManager.setchartLabels(_chartLabels, this.applicationVersionName + "_" + DBkeys.ELECTRICITYCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.ELECTRICITYMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.ELECTRICITYMIN);
        }
    }

    refreshMemoryChart(OChartData, OChartLabels, OMin, OMax) {

        this.electricityStatistics = OChartData;
        this.chartData = OChartData;
        this.chartLabels = OChartLabels;
        this.Min = OMin;
        this.Max = OMax;
        this.chartOptions = {
            responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        suggestedMin: this.suggestedMin,
                        suggestedMax: this.suggestedMax,
                        min: this.Min,
                        max: this.Max
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                },
                point: {
                    radius: 0
                }
            }
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/electricity/electricity-statistics/electricity-statistics.component.ts